import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  OutlinedInput,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useUserList from "../hooks/useUserList";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function UserListSelector({
  collectData = () => {},
  helperText = "",
  label = "Users",
}) {
  // const [selectedUserIndexes, setSelectedUserIndexes] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserIndexes, setSelectedUserIndexes] = useState([]);
  // const [users, setUsers] = useState([]);
  const { data: user } = useSelector((state) => state.user);

  const { userList, error } = useUserList(user.token);
  let users = userList.filter((u) => u.email !== user.email);
  // useEffect(() => {
  //     if(!user.token || users.length) return;
  //     getUserList(user.token).then(({data}) => {
  //         setUsers(data.data.filter(u => u.email !== user.email));
  //     })
  // }, [user.token])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedUserIndexes(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  useEffect(() => {
    // const ids = selectedUserIndexes.map(i => users[i].id);
    // console.log("selected indxs", selectedUserIndexes);
    // console.log("users", users);
    // setSelectedUsers(selectedUserIndexes.map(i => users[i]));
    collectData(selectedUserIndexes.map((i) => users[i]));
    // console.log(ids)
  }, [selectedUserIndexes]);

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        fullWidth
        value={selectedUserIndexes}
        onChange={handleChange}
        input={<OutlinedInput label={label} fullWidth />}
        renderValue={(selected) =>
          selected.map((s) => users[s].name).join(", ")
        }
        MenuProps={MenuProps}
      >
        {users.map((u, idx) => (
          <MenuItem key={idx} value={idx}>
            <Checkbox checked={selectedUserIndexes.indexOf(idx) > -1} />
            <ListItemText primary={u.name} />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
